import { isEmptyObject } from '@js/utils/toolbox';
import { reactive } from 'vue';

// Initial state
export const responseObjectInitial = () => ({
	alliance: {},
	equipment: [],
	airportPriceMap: {},
	airportDetails: {},
	airlineDetails: {},
	blacklistedAirlines: [],
	foreign: [],
	resultCount: 0,
	searchParameters: {},
	segments: {},
	travelAgent: [],
	trips: {},
	uniquePrices: [],
	uniqueAirportArrivals: [],
	uniqueAirportDepartures: [],
	uniqueAirportStops: [],
	uniqueBaggage: [],
	uniqueCabinBaggage: [],
	uniqueMaxTraveltimePerTrip: [],
	uniqueNumStops: [],
	uniquePaymentMethods: [],
	uniqueProducers: {},
	uniqueRebooking: [],
	uniqueTicketCategories: [],
	uniqueTicketFlexbilities: [],
	uniqueTimes: [],
	uniqueTimesOffset: [],
	uniqueTransferTimes: [],
	uniqueTravelMethods: [],
	uniqueWaittime: [],
	uniqueCabinTypes: []
});

// Reactive state
const state = reactive({
	response: responseObjectInitial()
});

// Mutations
const mutations = {
	set (payload) {
		if (isEmptyObject(payload)) {
			state.response = responseObjectInitial();
		} else {
			state.response = payload;
		}
	}
};

// Export a Composition API function to use the store
export const useResultQueryStore = () => ({
	state,
	...mutations
});
